module.exports = __webpack_public_path__ + "img/baseInfo_bg.b28c5cd.png";